import IncTextField from '../fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';

const ResetPasswordForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <IncTextField
        name="email"
        label={t('page.resetPassword.email.label')}
        data-testid="ResetEmailField"
      />
    </>
  );
};

export default ResetPasswordForm;
